export const required = (value) => (value || typeof value === "number" ? undefined : "Required");

export const maxLength = (max) => (value) => (value && value.length > max ? `Must be ${max} characters or less` : undefined);

export const max5 = maxLength(5);

export const max64 = maxLength(64);

export const max100 = maxLength(100);

export const max250 = maxLength(250);

export const minLength = (min) => (value) => (value && value.length < min ? `Must be ${min} characters or more` : undefined);

export const number = (value) => (value && isNaN(Number(value)) ? "Must be a number" : undefined);

export const minValue = (min) => (value) => (value && value < min ? `Must be at least ${min}` : undefined);

export const email = (value) =>
	value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? "Invalid email address" : undefined;

export const tooYoung = (value) => (value && value < 13 ? "You do not meet the minimum age requirement!" : undefined);

export const aol = (value) => (value && /.+@aol\.com/.test(value) ? "Really? You still use AOL for your email?" : undefined);

export const alphaNumeric = (value) => (value && /[^a-zA-Z0-9 ]/i.test(value) ? "Only alphanumeric characters" : undefined);

export const phoneNumber = (value) =>
	value && !/^(0|[1-9][0-9]{5,9})$/i.test(value) ? "Must be 6 to 10 digits" : undefined;

export const passwordMatch = (pass1, pass2) => (pass1 && pass2 && pass1 !== pass2 ? "Password does not match" : undefined);
export const time = (value) =>
	value && !/^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$/.test(value) ? "Invalid time format" : undefined;

export const max = (max) => (value) =>
	value && typeof value !== "number" && value > max ? `Must be ${max} or less` : undefined;

export const maxInt = max(2147483647);

export const min = (min) => (value) =>
	value && typeof value !== "number" && value < min ? `Must be ${min} or more` : undefined;

export const isInt = (value) => (value && !/^\d+$/.test(value) ? "Please provide a valid integer" : undefined);

export const isDec = (value) => (value && !(/^\d+\.\d{0,2}$/.test(value) || /^.\d{0,2}$/.test(value) || /^\d+$/.test(value)) ? "Please provide a valid number, up to 2 decimal places" : undefined);

export const isDec3 = (value) => (value && !( /^\d+\.\d{0,3}$/.test(value) || /^.\d{0,3}$/.test(value) || /^\d+$/.test(value)) ? "Please provide a valid number, up to 3 decimal places" : undefined);

export const array = (value) => (value && value.length > 0 ? undefined : "Required");

export const url = (value) =>
	value && !/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/i.test(value)
		? "Invalid url"
		: undefined;

export const youtube_url = (value) =>
	value && !/^(?:https?:\/\/)?(?:youtu\.be\/|(?:www\.)?youtube\.com\/watch(?:\.php)?\?.*v=)([a-zA-Z0-9\-_]+)/gm.test(value)
		? "Not a YouTube Video Url"
		: undefined;
